import { ImageProps, SrcSet } from "./types";
import classNames from "classnames";

export const Image = ({
  alt,
  sources,
  lowResImageSrc,
  src,
  width,
  height,
  objectFit,
  className,
  backgroundColor,
  objectPosition,
}: ImageProps): JSX.Element => {
  // Ensure alt text is provided and meaningful
  const getAccessibleAlt = () => {
    if (alt && alt.trim() !== "") {
      return alt;
    }
    // If no alt text provided, mark as decorative
    return "";
  };

  const accessibleAlt = getAccessibleAlt();
  const objectFitPositon = {
    objectFit,
    objectPosition,
  };

  const getSrcSets = () => {
    return sources
      ? Object.entries(sources).filter((entry) => entry[1].srcset)
      : [];
  };

  return (
    <picture className={"h-fit"}
      style={{
        backgroundColor: backgroundColor,
      }}
    >
      {getSrcSets().length ? (
        getSrcSets().map((srcSet: SrcSet) => (
          <source
            key={srcSet[0]}
            data-srcset={srcSet[1].srcset}
            type={srcSet[1].type}
          />
        ))
      ) : (
        <source data-srcset={src} />
      )}
      <img
        src={lowResImageSrc ? lowResImageSrc : src}
        data-src={src}
        alt={accessibleAlt}
        role={accessibleAlt === "" ? "presentation" : undefined}
        className={classNames(
          "lazyload max-w-full",
          className,
          {"w-full": !(width || height) }
        )}
        style={{ height, width, ...objectFitPositon }}
        loading="lazy"
      />
    </picture>
  );
};
